import type { Menu } from '@/router/types';
import type { RouteRecordNormalized } from 'vue-router';

import {QueryCommand} from 'xmgoing-server';
import { useAppStoreWithOut } from '@/store/modules/app';
import { usePermissionStore } from '@/store/modules/permission';
import { getAllParentPath } from '@/router/helper/menuHelper';
import { filter } from '@/utils/helper/treeHelper';
import {initTreeData, isUrl} from 'xmgoing-utils';
import { router } from '@/router';
import { PermissionModeEnum } from '@/enums/appEnum';
import { pathToRegexp } from 'path-to-regexp';
import {getSpaceMenusAction} from "@/api/sys/menu";
import {StorageUtils} from 'xmgoing-utils';


// ===========================
// ==========Helper===========
// ===========================

const getPermissionMode = () => {
  const appStore = useAppStoreWithOut();
  return appStore.getProjectConfig.permissionMode;
};


const isRoleMode = () => {
  return getPermissionMode() === PermissionModeEnum.ROLE;
};

async function getAsyncMenus() {
  //获取权限store
  const permissionStore = usePermissionStore();
  //如果已经缓存到vuex中 则直接使用
  if(permissionStore.getFrontMenuList.length>0){
    return permissionStore.getFrontMenuList.filter((item) => !item.hideMenu);
  }else{
    //如果缓存中不存在数据 则查询一次
    await permissionStore.buildRoutesAction();
    return permissionStore.getFrontMenuList.filter((item) => !item.hideMenu);
  }
}

/**
 * 加载系统开发菜单集合
 */
export const loadSystemMenus = async function (menusRef) {
  const queryCommand = new QueryCommand({ url: '/api/pe-portal/adminResource/getSystemMenu', method: 'POST' })
  queryCommand.executeQuery({
    params: { code: 'systemMenu' },
    successFun: (res:any) => {
      if (res && res.length > 0) {
        StorageUtils.addSessionItem('xmSystemMainDev', JSON.stringify(res));
        res.forEach((itemObj)=>{
          itemObj.source=itemObj.menuIcon;
        })
        menusRef.value = initTreeData(res,[],{id:'menuId',parentId:'parentId',children:'children'});
      }
    },
    page: false,
    showTip: false
  })
}

export const getMenus = async (): Promise<Menu[]> => {
  const menus = await getAsyncMenus();
  if (isRoleMode()) {
    const routes = router.getRoutes();
    return filter(menus, basicFilter(routes));
  }
  return menus;
};

/**
 * 获取当前空间的菜单id
 */
export const getSpaceMenus = async (spaceId:string): Promise<Menu[]> => {
  // const spaceIdMenus=StorageUtils.getSessionItem(spaceId+"-menus");
  // if(spaceIdMenus&&spaceIdMenus.length>0){
  //   try {
  //     return  JSON.parse(spaceIdMenus);
  //   }catch (e){
  //     StorageUtils.addSessionItem(spaceId+"-menus",null);
  //     getSpaceMenus(spaceId);
  //   }
  // }
  const dbMenus=await getSpaceMenusAction(spaceId);
  StorageUtils.addSessionItem(spaceId+"-menus",dbMenus);
  return (dbMenus as any);
};



export async function getCurrentParentPath(currentPath: string) {
  const menus = await getAsyncMenus();
  const allParentPath = await getAllParentPath(menus, currentPath);
  return allParentPath?.[0];
}

// Get the level 1 menu, delete children
export async function getShallowMenus(): Promise<Menu[]> {
  const menus = await getAsyncMenus();
  const shallowMenuList = menus.map((item) => ({ ...item, children: undefined }));
  if (isRoleMode()) {
    const routes = router.getRoutes();
    return shallowMenuList.filter(basicFilter(routes));
  }
  return shallowMenuList;
}

// Get the children of the menu
export async function getChildrenMenus(parentPath: string) {
  const menus = await getMenus();
  const parent = menus.find((item) => item.path === parentPath);
  if (!parent || !parent.children || !!parent?.meta?.hideChildrenInMenu) {
    return [] as Menu[];
  }
  if (isRoleMode()) {
    const routes = router.getRoutes();
    return filter(parent.children, basicFilter(routes));
  }
  return parent.children;
}

function basicFilter(routes: RouteRecordNormalized[]) {
  return (menu: Menu) => {
    const matchRoute = routes.find((route) => {
      if (isUrl(menu.path)) return true;

      if (route.meta?.carryParam) {
        return pathToRegexp(route.path).test(menu.path);
      }
      const isSame = route.path === menu.path;
      if (!isSame) return false;

      if (route.meta?.ignoreAuth) return true;

      return isSame || pathToRegexp(route.path).test(menu.path);
    });

    if (!matchRoute) return false;
    menu.icon = (menu.icon || matchRoute.meta.icon) as string;
    menu.meta = matchRoute.meta;
    return true;
  };
}
